$(function(){
	$('a[href*=\\#]:not([href=\\#])').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
			if ($target.length) {
				if($(this).parents('.menuBox').length){
					setTimeout(function(){
						var targetOffset = $target.offset().top;
						$('html,body').animate({scrollTop: targetOffset}, 1000);
					},100);
				}else{
					var targetOffset = $target.offset().top;
					$('html,body').animate({scrollTop: targetOffset}, 1000);
				}
				return false;
			}
		}
	});
});

$(window).on('load',function(){
	var localLink = window.location+'';
	if(localLink.indexOf("#") != -1 && localLink.slice(-1) != '#'){	
		localLink = localLink.slice(localLink.indexOf("#")+1);
		$('html,body').animate({scrollTop: $('#'+localLink).offset().top}, 500);
	}
});


$(window).on('load',function(){
  $("#splash").delay(1500).fadeOut('slow');
  $("#splash_logo").delay(1200).fadeOut('slow');
});

// 店舗情報スライダー
const mySwiper_thumb = new Swiper('.shop_slider-sub', {
	slidesPerView: 4,
	spaceBetween: 15,
	grabCursor: true,
	breakpoints: {
		500: {
			slidesPerView: 6,
		},
		897: {
			slidesPerView: 8,
		},
	},
});
const mySwiper_main = new Swiper('.shop_slider-main', {
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
  autoplay: {
    delay: 2000,
  },
	loop: true,
  loopAdditionalSlides: 1,
	speed: 2000,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	thumbs: {
		swiper: mySwiper_thumb,
	},
});

// 商品詳細スライダー
const itemSlider = new Swiper('.item_slider', {
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
	loop: true,
    loopAdditionalSlides: 1,
	speed: 1500,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});


const img_02 = new Swiper('.img_02', {
	effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  slidesPerView: 1,
	loop: true,
  loopAdditionalSlides: 1,
	speed: 3000,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
});

// モーダル
window.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("modal");
  const openModalBtns = document.querySelectorAll(".modalOpen");
  const closeModalBtns = document.querySelectorAll(".modalClose");
  const swiper = new Swiper(".swiper", {
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    spaceBetween: 30,
  });

  openModalBtns.forEach((openModalBtn) => {
    openModalBtn.addEventListener("click", () => {
      const modalIndex = openModalBtn.getAttribute('data-modal');
      swiper.slideTo(modalIndex);
      modal.classList.add("is-active");
    });
  });

  closeModalBtns.forEach((closeModalBtn) => {
    closeModalBtn.addEventListener("click", () => {
      modal.classList.remove("is-active");
    });
  });
});